import Processing from 'ext-ui/components/Processing/Processing'
import React from 'react'
import * as style from 'src/app/BulkInvite/components/LoadingState.style'

interface LoadingStateProps {
  title: string
  detail?: string
}

/** Centered spinner + title + detail — reused for parse / diff / submit waits. */
const LoadingState: React.FC<LoadingStateProps> = ({ title, detail }) => (
  <div css={style.container} role="status" aria-live="polite">
    <Processing variant="primary" width={40} height={40} />
    <div css={style.title}>{title}</div>
    {detail !== undefined && <div css={style.detail}>{detail}</div>}
  </div>
)

export default LoadingState
